import { useState } from "react";
import { Button, Modal, Table, Form, Input, Popconfirm } from "antd";
import { UserAddOutlined, TeamOutlined, DeleteOutlined, UserSwitchOutlined, StarOutlined } from "@ant-design/icons";
import { Translate } from "../../translate";
import { getStore } from "../../utils/global";
import Loading from "../Loading";
import { useMutation, useQuery } from "react-query";
import axios from "../../utils/axios";

const SelectContacts = ({ isOpen, onCancel, onSelect }) => {
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const [form] = Form.useForm();
  const [activeTab, setActiveTab] = useState("Fav");
  const [searchInput, setSearchInput] = useState("");
  const [searchList, setSearchList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const user = getStore("user");
  const {
    data: userContacts,
    isLoading: userContactLoading,
    refetch: userRefetch,
  } = useQuery({
    queryKey: ["get_user_contacts", user.kdss_user],
    queryFn: () =>
      axios.post(
        "client/api/user/contacts/list",
        {
          page: 0,
          pper: 30,
          search: searchInput ?? "",
        },
        { showErrorMessage: true },
      ),
    enabled: activeTab === "Fav",
    select: ({ data }) =>
      data?.list?.map((e, i) => {
        return { ...e, key: i };
      }) || [],
  });

  const { data: sysContacts, isLoading: sysContactLoading } = useQuery({
    queryKey: ["get_sys_contacts"],
    queryFn: () =>
      axios.post(
        "client/api/user/contacts",
        {
          page: 0,
          pper: 10,
          search: searchInput ?? "",
        },
        { showErrorMessage: true },
      ),
    enabled: activeTab === "Sys",
    select: ({ data }) =>
      data?.contacts?.map((e, i) => {
        return { ...e, key: i };
      }) || [],
  });

  const searchContacts = (valraw) => {
    const searchVal = valraw.toLowerCase().trim();
    setSearchInput(searchVal);

    const contactsToSearch = activeTab === "Fav" ? userContacts : activeTab === "Sys" ? sysContacts : [];

    if (!searchVal || !contactsToSearch.length) {
      setSearchList([]);
      return;
    }

    const isEmail = searchVal.includes("@");
    const isPhone = /^\d+$/.test(searchVal);

    const result = contactsToSearch.filter((contact) => {
      const email = contact.email_address || contact.kdss_email || "";
      const phone = contact.msisdn || contact.kdss_msisdn || "";
      const name = contact.name || contact.kdss_name || "";

      if (isEmail) return email.toLowerCase().includes(searchVal);
      if (isPhone) return phone.toLowerCase().includes(searchVal);
      return name.toLowerCase().includes(searchVal) || email.toLowerCase().includes(searchVal);
    });

    setSearchList(result);
  };

  const { mutate: deleteContact } = useMutation({
    mutationKey: ["delete_user_contact"],
    mutationFn: (id) => axios.post("client/api/user/contacts/remove", { id }, { showErrorMessage: true, showSuccessMessage: true }),
    onSuccess: () => userRefetch(),
  });

  const addToFav = (el) => {
    let data = {
      email_address: el.kdss_email,
      msisdn: el.kdss_msisdn,
      name: el.kdss_name,
    };

    addUserContact(data);
  };

  const tabs = [
    {
      icon: <UserAddOutlined />,
      label: "New",
    },
    {
      icon: <TeamOutlined />,
      label: "Fav",
    },
    {
      icon: <UserSwitchOutlined />,
      label: "Sys",
    },
  ];

  const { mutate: addUserContact, isLoading: addContactLoading } = useMutation({
    mutationKey: ["add_user_contact"],
    mutationFn: (data) => axios.post("client/api/user/contacts/add", data, { showErrorMessage: true, showSuccessMessage: true }),
    onSuccess: () => {
      setSearchInput("");
      setActiveTab("Fav");
      userRefetch();
    },
  });

  const renderTab = (obj) => {
    switch (activeTab) {
      case "New":
        return (
          <div className="add_contacts">
            <Form layout="vertical" form={form} onFinish={addUserContact}>
              <Form.Item name="name" rules={[{ required: true, message: "required." }]} label={obj["Name"]}>
                <Input placeholder="John Doe" />
              </Form.Item>
              <Form.Item name="msisdn" rules={[{ required: true, message: "required." }]} label={obj["MSISDN"]}>
                <Input placeholder="12341234" />
              </Form.Item>
              <Form.Item name="email_address" rules={[{ required: true, message: "required." }]} label={obj["Email"]}>
                <Input placeholder="John@gmail.com" type="email" />
              </Form.Item>
            </Form>
          </div>
        );
      case "Fav":
        return (
          <div style={{ overflow: "auto", maxHeight: "500px" }}>
            <Table
              columns={[
                { title: "Name", dataIndex: "name", key: "name" },
                { title: "MSISDN", dataIndex: "msisdn", key: "msisdn" },
                { title: "Email", dataIndex: "email_address", key: "email_address" },
                {
                  title: "Action",
                  key: "action",
                  render: (el) => (
                    <div className="contact_delete">
                      <Popconfirm title="Are you sure to delete this contact ?" okText="Delete" onConfirm={() => deleteContact(el.id)}>
                        <DeleteOutlined style={{ cursor: "pointer" }} />
                      </Popconfirm>
                    </div>
                  ),
                },
              ]}
              dataSource={searchInput === "" ? userContacts : searchList}
              loading={userContactLoading}
              pagination={false}
              rowSelection={{
                type: "radio",
                onChange: (_, i) => {
                  setSelectedUser(i[0]);
                },
              }}
            />
          </div>
        );
      default:
        return (
          <div style={{ overflow: "auto", maxHeight: "500px" }}>
            <Table
              columns={[
                { title: "Name", dataIndex: "kdss_name", key: "kdss_name" },
                { title: "MSISDN", dataIndex: "kdss_msisdn", key: "kdss_msisdn" },
                { title: "Email", dataIndex: "kdss_email", key: "kdss_email" },
                {
                  title: "Action",
                  key: "action",
                  render: (el) => (
                    <div
                      style={{
                        textAlign: "center",
                        color: "blueviolet",
                        cursor: "pointer",
                      }}>
                      <StarOutlined color="blue" onClick={() => addToFav(el)} />
                    </div>
                  ),
                },
              ]}
              loading={sysContactLoading}
              dataSource={searchInput === "" ? sysContacts : searchList}
              pagination={false}
              rowSelection={{
                type: "radio",
                onChange: (_, i) => {
                  let tmp = i[0];
                  tmp.email_address = tmp.kdss_email;
                  tmp.msisdn = tmp.kdss_msisdn;
                  tmp.name = tmp.kdss_name;
                  setSelectedUser(tmp);
                },
              }}
            />
          </div>
        );
    }
  };

  return (
    <Modal
      destroyOnClose
      open={isOpen}
      className="nopaddingwrapper selectcontact"
      onCancel={onCancel}
      width={"max-content"}
      title={Translate[ln].NewDoc.Participants.SelectContact}
      footer={
        activeTab === "New" ? (
          <Button type="primary" onClick={addUserContact} loading={addContactLoading}>
            {Translate[ln].NewDoc.Participants.Create}
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={() => {
              if (selectedUser) onSelect(selectedUser);
            }}>
            {Translate[ln].NewDoc.Participants.Select}
          </Button>
        )
      }>
      <Loading loading={userContactLoading || sysContactLoading} />
      <div style={{ padding: "10px" }}>
        <Input.Search
          placeholder={Translate[ln].NewDoc.Participants.placeholder4}
          onSearch={(searchInput) => searchContacts(searchInput)}
          disabled={activeTab === "New"}
          allowClear
          style={{ width: "80%", paddingLeft: "25%" }}
        />
      </div>
      <div className="contacts">
        <div className="contacts_sidebar">
          {tabs.map((e, i) => (
            <div
              onClick={() => {
                setSelectedUser(null);
                setSearchInput("");
                setActiveTab(e.label);
              }}
              key={"contact_tab_" + i}
              className={`sidebar_item ${activeTab === e.label ? "active" : "non_active"}`}
              role="button">
              {e.icon}
              {Translate[ln].NewDoc.Participants[e.label]}
            </div>
          ))}
        </div>
        <div style={{ position: "relative" }} className="contacts_content">
          {renderTab(Translate[ln].NewDoc.Participants)}
        </div>
      </div>
    </Modal>
  );
};

export default SelectContacts;
